import { Component, HostListener, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { KingClubAssets } from '../../shared/enum/icons';
import { MatDialog } from '@angular/material/dialog';
import { AccountSwitchDialogComponent } from '../../king-club/account-switch-dialog/account-switch-dialog.component';
import { TitleService } from '../../shared/services/title.service';
import { Meta } from '@angular/platform-browser';
import { CountUpDirective } from '../../shared/directive/count-up.directive';
import { Router, RouterLink } from '@angular/router';
import { isPlatformBrowser, NgClass } from '@angular/common';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { MatButtonModule } from '@angular/material/button';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { AppStateService } from '../../shared/services/app-state.service';
import { StateService } from '../../shared/services/storage/state.service';
@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: true,
    imports: [CountUpDirective, RouterLink, NgClass, FooterComponent, MatButtonModule]
})
export class ClubLandingPageComponent implements OnInit {
  dialog = inject(MatDialog);
  private titleService = inject(TitleService);
  private meta = inject(Meta);
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);
  private appStateService = inject(AppStateService);
  private stateService = inject(StateService);
  screenWidth: number;
  isMobileView = false;
  kingAssets = KingClubAssets;
  activeIndex = 0;
  socialMediaLinks = [
    {
      link: 'https://instagram.com/king_giftcard/',
      icon: this.kingAssets.InstagramLogo,
      alt: 'King Instagram link'
    },
    {
      link: 'https://t.me/kingiftcard',
      icon: this.kingAssets.TelegramLogo,
      alt: 'Telegram Instagram link'
    },
    {
      link: 'https://www.linkedin.com/company/ez-pin',
      icon: this.kingAssets.LinkedinLogo,
      alt: 'Linkedin Instagram link'
    },
    {
      link: 'https://x.com/kingiftcard',
      icon: this.kingAssets.XLogo,
      alt: 'X Instagram link'
    },
    {
      link: 'https://facebook.com/kingiftcard',
      icon: this.kingAssets.FacebookLogo,
      alt: 'Facebook Instagram link'
    }
  ];

  summaryItems = [
    'Earn Rewards',
    'Flexible Rewards',
    'Extra Discounts',
    'Exclusive Deals'
  ];

  whyKingClubItems = [
    {
      title: 'Growing Rewards',
      description: `Every purchase moves you forward. With KingClub, your spending turns into real value on groceries, fashion, or gadgets, unlocking better rewards as you level up.`
    },
    {
      title: 'World of Options',
      description: `KingClub connects you with hundreds of top brands and retailers, giving you the freedom to earn rewards wherever you shop. From global marketplaces to local favorites, every purchase brings you closer to exclusive benefits designed for your lifestyle.`
    },
    {
      title: 'Ease of Use',
      description: `Getting Rewards has never been easier. With KingClub, there are no hidden fees just spend your crypto or use the Reward Program to Enjoy automatic rewards.`
    },
    {
      title: 'Exclusive Deals',
      description: `Becoming a KingClub member opens the door to exclusive deals, premium perks, and insider-only rewards that non-members can only dream about, plus early access to special events, limited-time rewards, and personalized offers just for you.`
    }
  ];

  howKingClubWorksItems = [
    {
      step: '1',
      title: 'Shop',
      icon: this.kingAssets.Shop,
      description: 'Enjoy exclusive discounts every time you purchase.'
    },
    {
      step: '2',
      title: 'Save',
      icon: this.kingAssets.EarnDiscount,
      description:
        'Collect valuable rewards with every eligible transaction automatically!'
    },
    {
      step: '3',
      title: 'Redeem',
      icon: this.kingAssets.Redeem,
      description:
        'Use your rewards whenever it suits you. It’s simple, flexible, and made for you.'
    }
  ];

  testimonials = [
    {
      user: 'Olga Ivanov',
      comment:
        'I’ve earned over $200 in cash back this year – it’s like free money!',
      avatar: this.kingAssets.Avatar1
    },
    {
      user: 'Alex Flores',
      comment:
        'It’s so easy to use, and the cashback adds up quickly. Highly recommend!',
      avatar: this.kingAssets.Avatar2
    },
    {
      user: 'Sarah brown',
      comment:
        'KingClub makes shopping so rewarding. I love the exclusive deals.',
      avatar: this.kingAssets.Avatar3
    },
    {
      user: 'Austin Gonzalez',
      comment:
        'I’ve earned over $200 in cash back this year – it’s like free money!',
      avatar: this.kingAssets.Avatar4
    }
  ];

  faqItems = [
    {
      question: 'Is KingClub really free?',
      answer:
        'Yes, joining KingClub is completely free. Enjoy exclusive rewards, rewards, and gift card opportunities with no membership fees.',
      isExpanded: false
    },
    {
      question: 'How long does it take to receive my rewards?',
      answer:
        'You receive your savings instantly in your main wallet right after completing your purchase.',
      isExpanded: false
    },
    {
      question: 'Is my personal information safe with KingClub?',
      answer:
        'We are committed to safeguarding your personal details through secure, encrypted systems that meet global data protection standards',
      isExpanded: false
    },
    {
      question: 'How do I redeem my rewards?',
      answer:
        "You can use the amount you received in your wallet anytime you like; It's ready whenever you are!",
      isExpanded: false
    },
    {
      question: 'Can I switch back from KingClub to a previous setup later?',
      answer: `After upgrading to KingClub, switching back to your previous setup won’t be available. But you’ll retain all your savings and enjoy ongoing perks such as enhanced rates and exclusive offers when buying gift cards.`,
      isExpanded: false
    }
  ];

  loyaltyLevels = [
    {
      level: 'Bronze',
      icon: this.kingAssets.BronzeBadge,
      percentage: 3,
      top:  '9px',
      right: '220px'
    },
    {
      level: 'Silver',
      icon: this.kingAssets.SilverBadge,
      percentage: 6,
      top:  '77px',
      right: '258px'
    },
    {
      level: 'Gold',
      icon: this.kingAssets.GoldBadge,
      percentage: 10,
      top:  '145px',
      right:  '296px'
    },
    {
      level: 'Platinum',
      icon: this.kingAssets.PlatinumBadge,
      percentage: 12,
      top:  '213px',
      right: '334px'
    },
    {
      level: 'Diamond',
      icon: this.kingAssets.DiamondBadge,
      percentage: 16,
      top:  '281px',
      right:  '372px'
    }
  ];

  col1 = [];
  col2 = [];

  expandedFaqIndex = -1;
  hoveredLevelIndex = -1;
  membersCount = 500;
  membersDuration = 5000;

  // @ViewChild('testimonialContainer') testimonialContainer!: ElementRef;

  ngOnInit(): void {
    const profile =
      this.appStateService.getProfile() ?? this.stateService.userProfile();
    if (this.localStorageService.isLoggedIn && profile?.is_club_member) {
      this.router.navigate(['/kingclub/club-levels']);
      return;
    }

    if(isPlatformBrowser(this.platformId)){
      this.screenWidth = window.innerWidth;
      this.isMobileView = this.screenWidth <= 960;
      this.setLoyaltyLevel();
    }
    this.titleService.updateTitle(
      ' Rewards System for Crypto Gift Card Buyers | Kingift'
    );
    this.meta.addTag({
      name: 'description',
      content:
        'Discover the KingClub Rewards System, the smarter way to buy gift cards with crypto. Earn exclusive perks, unlock member-only benefits, and enjoy instant global delivery.'
    });
    this.activeIndex = 0;
    let items = Math.ceil(this.faqItems.length / 2);
    this.col1 = [...this.faqItems.slice(0, items)];
    this.col2 = [...this.faqItems.slice(items)];

    this.screenWidth 
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = (event.target as Window).innerWidth;
    this.isMobileView = this.screenWidth <= 960;
    this.setLoyaltyLevel();
  }

  toggleFaq(event: Event, index: number) {
    event.preventDefault();
    if (this.expandedFaqIndex === index) {
      this.expandedFaqIndex = -1;
    } else {
      this.expandedFaqIndex = index;
    }
  }

  joinKingClubBtnClicked(joinAfterLogin?: boolean) {
    this.dialog.open(AccountSwitchDialogComponent, {
      maxWidth: '600px',
      panelClass: 'switch-account-dialog',
      data: {
        joinAfterLogin: joinAfterLogin ?? false
      }
    });
  }

  setLoyaltyLevel(){
    this.loyaltyLevels = [
      {
        level: 'Bronze',
        icon: this.kingAssets.BronzeBadge,
        percentage: 3,
        top: this.isMobileView ? '12px' : '9px',
        right: this.isMobileView ? '124px' : '220px'
      },
      {
        level: 'Silver',
        icon: this.kingAssets.SilverBadge,
        percentage: 6,
        top: this.isMobileView ? '76px' : '77px',
        right: this.isMobileView ? '156px' : '258px'
      },
      {
        level: 'Gold',
        icon: this.kingAssets.GoldBadge,
        percentage: 10,
        top: this.isMobileView ? '140px' : '145px',
        right: this.isMobileView ? '188px' : '296px'
      },
      {
        level: 'Platinum',
        icon: this.kingAssets.PlatinumBadge,
        percentage: 12,
        top: this.isMobileView ? '204px' : '213px',
        right: this.isMobileView ? '225px' : '334px'
      },
      {
        level: 'Diamond',
        icon: this.kingAssets.DiamondBadge,
        percentage: 16,
        top: this.isMobileView ? '268px' : '281px',
        right: this.isMobileView ? '260px' : '372px'
      }
    ];
  }

  // scrollLeft() {
  //   if (this.activeIndex > 0) {
  //     this.activeIndex--;
  //     this.scrollToActive();
  //   }
  // }

  // scrollRight() {
  //   if (this.activeIndex < this.testimonials.length - 1) {
  //     this.activeIndex++;
  //     this.scrollToActive();
  //   }
  // }

  // scrollToActive() {
  //   const container = this.testimonialContainer.nativeElement;
  //   const testimonialBoxes = container.querySelectorAll('.testimonial-box');
  //   const activeBox = testimonialBoxes[this.activeIndex];

  //   if (activeBox) {
  //     container.scrollTo({
  //       left: activeBox.offsetLeft,
  //       behavior: 'smooth'
  //     });
  //   }
  // }
}
